export type PageID = "DISCOVER_PUBLIC" | "DISCOVER_LOGGED_IN" | "SHORTLIST" | "MY_PROFILE_PREVIEW" | "INTEREST";

export interface PageConfig {
  backLink?: string;
  backText?: string;
  containerSize: "xl" | "fluid";
  hideBackButton: boolean;
  hideInfoBanner: boolean;
  hideInterestCTA: boolean;
  disableShortlist: boolean;
}

export const PAGE_CONFIG: Record<PageID, PageConfig> = {
  DISCOVER_PUBLIC: {
    backLink: "/",
    backText: "Back to Discovery",
    containerSize: "xl",
    hideBackButton: false,
    hideInfoBanner: false,
    hideInterestCTA: false,
    disableShortlist: false,
  },
  DISCOVER_LOGGED_IN: {
    backLink: "/my-discovery",
    backText: "Back to Discovery",
    containerSize: "fluid",
    hideBackButton: false,
    hideInfoBanner: false,
    hideInterestCTA: false,
    disableShortlist: false,
  },
  SHORTLIST: {
    backLink: "/shortlist",
    backText: "Back to Shortlist",
    containerSize: "fluid",
    hideBackButton: false,
    hideInfoBanner: true,
    hideInterestCTA: false,
    disableShortlist: false,
  },
  MY_PROFILE_PREVIEW: {
    containerSize: "fluid",
    hideBackButton: true,
    hideInfoBanner: true,
    hideInterestCTA: true,
    disableShortlist: true,
  },
  INTEREST: {
    backLink: "/requests",
    backText: "Back to Interests",
    containerSize: "fluid",
    hideBackButton: false,
    hideInfoBanner: false,
    hideInterestCTA: false,
    disableShortlist: false,
  },
};
